import React, { useEffect, useState } from 'react';
import FormControl from '@mui/material/FormControl';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import TextField from '@mui/material/TextField';
import Alert from '@mui/material/Alert';
import OutlinedInput from '@mui/material/OutlinedInput';
import FormHelperText from '@mui/material/FormHelperText';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import dayjs from 'dayjs';
import 'dayjs/locale/ru';

export default function AddWorkerModalLP({ setAddWindowOpen }) {                   //добавление работы, доступное обычному админу, можно добавлять только мойщиков 1 и 2 ранга
  
const [newWorker, setNewWorker]=useState([]);
const api_url = process.env.REACT_APP_API_URL;
const complex_name = localStorage.getItem('complex_name');
const [saveStatus, setSaveStatus] = useState("");
const [saveButtonDisable, setSaveButtonDisable] = useState(true);                    //по умолчанию кнопка сабмит выключена, проверяем, что номер телефона введен верно, после этого включаем ее 
const availableRoles = [{role_value: "car_washer", role_label:"Мойщик"}, {role_value: "quality_control", role_label:"Контроль качества"}, {role_value: "cashier", role_label:"Кассир"}]
const [selectedRoles, setSelectedRoles] = useState([]);
// const [complexName, setComplexName] = useState([]);

function handleChange(e) {
    setNewWorker({
      ...newWorker,
      [e.target.name]: e.target.value
    });
}

const handleDateChange = (newValue) => {
  setNewWorker((newWorker) => ({
    ...newWorker,
    birthDate: newValue,
  }));
};

async function createWorker() {
    
    setSaveButtonDisable(true);                               //сразу выключаю кнопку сохранения, чтобы не нажимали дважды

    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': localStorage.getItem('token') },
        body: JSON.stringify({phone_number: newWorker.phoneNumber, full_name: newWorker.fullName, rank: newWorker.rank, complex_name: complex_name, role: "car_washer", birth_date: newWorker.birthDate})
    };

    const saving_visit = await fetch(api_url+"/api/addWorker", requestOptions);

    const body = await saving_visit.json();
    if (body.message === "Worker added successfully!") {
      setSaveStatus("success");
      setTimeout(() => { if (setAddWindowOpen) setAddWindowOpen(false); }, 900);   //автозакрытие после успешного добавления
    }
    else {
      setSaveStatus("error");
      setSaveButtonDisable(false);
    }
}

    React.useEffect(() => {                           //блокируем кнопку, пока не заполнены обязательные поля
        const phoneOk = /^\+\d{11}$/.test(newWorker.phoneNumber || "");   //номер в формате +79111234567
        const formOk = phoneOk && !!(newWorker.fullName && newWorker.fullName.trim()) && !!newWorker.rank;
        setSaveButtonDisable(!formOk);
    }, [newWorker.phoneNumber, newWorker.fullName, newWorker.rank])

return (
    <div className='edit-worker-modal'>
    <h1 className="modal-header"> Добавить сотрудника </h1>
      <Box sx={{ maxWidth: 550, margin: `auto`, pt: 5, pb: 5 }}>

        <FormControl sx={{mb:1.5, mt:1.5}} fullWidth >
        <InputLabel htmlFor="component-outlined">ФИО сотрудника</InputLabel>
        <OutlinedInput
          id="worker_name_input"
          name="fullName"
          value={newWorker.fullName}
          onChange={handleChange}
          label="ФИО сотрудника"
        />
        </FormControl>

        <FormControl sx={{ mb: 1.5, mt: 1.5 }} fullWidth>
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ru">
        <DatePicker
          id="birth-date-picker"
          label="Дата рождения"
          name="birthDate"
          value={newWorker.birthDate}
          onChange={handleDateChange}
        />
        </LocalizationProvider>
        </FormControl>


        <FormControl sx={{mb:1.5, mt:1.5}} fullWidth >
        <InputLabel id="demo-simple-select-label">Ранг</InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="rank_chosing"
          name="rank"
          value={newWorker.rank}
          label="Ранг"
          onChange={handleChange}
        >
        <MenuItem value={1}>1</MenuItem>
        <MenuItem value={2}>2</MenuItem>
        <MenuItem value={3}>3</MenuItem>
        <MenuItem value={4}>4</MenuItem>
        </Select>
        </FormControl>


        <FormControl sx={{mb:1.5, mt:1.5}} fullWidth >
        <InputLabel htmlFor="component-outlined">Номер телефона сотрудника</InputLabel>
        <OutlinedInput
          id="worker_phone_input"
          name="phoneNumber"
          value={newWorker.phoneNumber}
          onChange={handleChange}
          label="Номер телефона сотрудника"
        />
        <FormHelperText id="phone-helper-text">Номер телефона в формате +79314445566</FormHelperText>
        </FormControl>

        <Box sx={{ display: 'flex', gap: 2, mt: 1.5, mb: 1.5 }}>
            <Button variant="outlined" fullWidth onClick={() => setAddWindowOpen && setAddWindowOpen(false)}>Отмена</Button>
            <Button variant="contained"
                fullWidth
                disabled={saveButtonDisable}
                color="success"
                onClick={() => createWorker()}>Добавить сотрудника</Button>
        </Box>
        {saveStatus === "error" && <Alert severity="error">Ошибка, проверьте правильность введённых данных!</Alert>}
        {saveStatus === "success" && <Alert severity="success">Сотрудник добавлен</Alert>}
        </Box>
    </div>
)}